import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Time Period Selector Component
 * Provides consistent time period selection interface
 */
const TimePeriodSelector = ({ timePeriod, onTimePeriodChange }) => {
  const { t } = useTranslation();

  const timePeriods = [
    { key: "week", label: "history.timePeriod.week" },
    { key: "month", label: "history.timePeriod.month" },
    { key: "year", label: "history.timePeriod.year" },
  ];

  return (
    <div className="flex justify-center mb-4">
      <div className="bg-primary/80 rounded-lg p-1 flex space-x-1">
        {timePeriods.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => onTimePeriodChange(key)}
            className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
              timePeriod === key
                ? "bg-secondary text-white"
                : "text-white/70 hover:text-white"
            }`}
          >
            {t(label)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimePeriodSelector;
